module.exports = __webpack_public_path__ + "img/delete-icon.fe3d586a.svg";